var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssembled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9016 13.6816L12.7985 23.9043",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7353 18.388V8.97529C21.7353 8.83442 21.6988 8.69609 21.6295 8.57442C21.5601 8.45275 21.4604 8.35211 21.3406 8.2828L13.1808 3.56195C13.0641 3.49445 12.9324 3.45898 12.7984 3.45898C12.6644 3.45898 12.5327 3.49445 12.416 3.56195L4.25619 8.2828C4.13638 8.35211 4.0367 8.45275 3.96735 8.57442C3.898 8.69609 3.86145 8.83442 3.86145 8.97529V18.388C3.86145 18.5288 3.898 18.6672 3.96735 18.7888C4.0367 18.9105 4.13638 19.0111 4.25619 19.0805L12.416 23.8013C12.5327 23.8688 12.6644 23.9043 12.7984 23.9043C12.9324 23.9043 13.0641 23.8688 13.1808 23.8013L21.3406 19.0805C21.4604 19.0111 21.5601 18.9105 21.6295 18.7888C21.6988 18.6672 21.7354 18.5288 21.7353 18.388V18.388Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.629 8.57336L12.9016 13.6815L3.96863 8.57227",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5715 15.7204V10.9477L8.55884 5.79297",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssembled);
export default __webpack_public_path__ + "static/media/assembled.19a369a278c2a25c10122dbea33a2194.svg";
export { ForwardRef as ReactComponent };